import { useMemo } from 'react';
import { encode } from 'uqr';

interface QrCodeProps {
  value: string;
  label: string;
  size?: number;
}

/**
 * Renders `value` as a QR code in inline SVG, generated in the browser so a
 * TOTP secret never leaves the page for a third-party QR service. Dark
 * modules on a white background with a 4-module quiet zone, as scanners
 * expect regardless of the app theme.
 */
export function QrCode({ value, label, size = 192 }: QrCodeProps) {
  const { path, dimension } = useMemo(() => {
    const qr = encode(value, { ecc: 'M', border: 4 });
    let d = '';
    qr.data.forEach((row, y) =>
      row.forEach((dark, x) => {
        if (dark) d += `M${x} ${y}h1v1h-1z`;
      }),
    );
    return { path: d, dimension: qr.size };
  }, [value]);

  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${dimension} ${dimension}`}
      shapeRendering="crispEdges"
      className="rounded-md"
    >
      <rect width={dimension} height={dimension} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  );
}
